import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, styled } from '@material-ui/core';

const WrapperButton = styled('button')({
  display: 'flex',
  gap: 10,
  alignItems: 'center',
  background: 'transparent',
  border: 0,
  outline: 0,
  padding: 0,
  margin: 0,
  cursor: 'pointer',

  '&:focus': {
    border: 0,
    outline: 0,
  }
})
const CustomizedAvatar = ({ avatar, className, initials, onClick, children }) => {
  if (avatar) {
    return (
      <WrapperButton onClick={onClick}>
        <Avatar
          className={className}
          data-testid="header-avatar-test-id"
          src={avatar}
        />
        {children}
      </WrapperButton>
    );
  }

  return (
    <WrapperButton onClick={onClick}>
      <Avatar
        className={className}
        data-testid="header-avatar-test-id"
      >
        {initials}
      </Avatar>
      {children}
    </WrapperButton>
  );
};

CustomizedAvatar.defaultProps = { initials: '' };

CustomizedAvatar.propTypes = {
  className: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  initials: PropTypes.string
};

export default CustomizedAvatar;
